import { Routes } from '@angular/router';
import { authGuard } from '@nstep-common/core';

import {
	permissionsByRoute,
	LayoutComponent,
	UnderMaintenanceComponent
} from '@nstep-public/shared';

import {
	AddBalanceComponent,
	BalanceComponent,
	EntitlementCheckComponent,
	LoginComponent,
	OnlineTransactionsComponent,
	ReportsComponent,
	SelectLocationComponent,
	TransactionHistoryComponent
} from '@nstep-public/pages';

export const routes: Routes = [
	{
		path: 'login',
		component: LoginComponent,
	},
	{
		path: 'login/local',
		component: LoginComponent,
	},
	{
		path: 'select-location',
		canActivate: [authGuard(permissionsByRoute)],
		component: SelectLocationComponent,
	},
	{
		path: '',
		component: LayoutComponent,
		canActivate: [authGuard(permissionsByRoute)],
		children: [
			{
				path: 'add-balance',
				canActivate: [authGuard(permissionsByRoute)],
				component: AddBalanceComponent,
			},
			{
				path: 'balance',
				canActivate: [authGuard(permissionsByRoute)],
				component: BalanceComponent,
			},
			{
				path: 'entitlement-check',
				canActivate: [authGuard(permissionsByRoute)],
				component: EntitlementCheckComponent
			},
			{
				path: 'online-transactions',
				canActivate: [authGuard(permissionsByRoute)],
				component: OnlineTransactionsComponent,
			},
			{
				path: 'reports',
				canActivate: [authGuard(permissionsByRoute)],
				component: ReportsComponent
			},
			{
				path: 'transaction-history',
				canActivate: [authGuard(permissionsByRoute)],
				component: TransactionHistoryComponent,
			},
			{
				path: 'under-maintenance',
				canActivate: [authGuard],
				component: UnderMaintenanceComponent
			},
			{
				path: '**',
				redirectTo: ''
			}

		]
	}
];